var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdminSeat = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.501,
    y1: -0.438,
    x2: 1.448,
    y2: 1.582,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13073",
    "data-name": "Group 13073",
    transform: "translate(-1654 -1030)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12994",
    "data-name": "Group 12994",
    transform: "translate(1006 335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    transform: "translate(648 695)",
    stroke: "#a3a3a3",
    strokeWidth: 5,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 34,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_12125",
    "data-name": "Path 12125",
    transform: "translate(1670.769 1046.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12133",
    "data-name": "Path 12133",
    d: "M504.641-130.066a1.874,1.874,0,0,0-1.617-1.285l-10.193-.931-4.032-9.436a1.876,1.876,0,0,0-2.462-.991,1.875,1.875,0,0,0-.991.991l-4.033,9.436-10.2.925a1.879,1.879,0,0,0-1.7,2.045,1.876,1.876,0,0,0,.633,1.24l7.712,6.758L475.484-111.3a1.876,1.876,0,0,0,1.407,2.248,1.875,1.875,0,0,0,1.385-.22l8.795-5.256,8.792,5.256a1.877,1.877,0,0,0,2.574-.646,1.882,1.882,0,0,0,.22-1.383l-2.272-10.01,7.713-6.758A1.878,1.878,0,0,0,504.641-130.066Z",
    transform: "translate(-467.265 145.001)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12134",
    "data-name": "Path 12134",
    d: "M497.463-106.221a3.989,3.989,0,0,1-2.057-.573l-7.694-4.6-7.7,4.6a3.989,3.989,0,0,1-2.964.467,3.988,3.988,0,0,1-2.505-1.782,3.985,3.985,0,0,1-.51-3.032l1.994-8.762-6.753-5.916a4.012,4.012,0,0,1-1.354-2.654,4.029,4.029,0,0,1,3.632-4.378l8.929-.81,3.531-8.259a4,4,0,0,1,2.121-2.121,4.028,4.028,0,0,1,5.274,2.122l3.528,8.259,8.922.816a4,4,0,0,1,3.456,2.754,4.013,4.013,0,0,1-1.164,4.268L499.4-119.9l1.991,8.767a4.007,4.007,0,0,1-.473,2.959,3.991,3.991,0,0,1-2.468,1.831A4.076,4.076,0,0,1,497.463-106.221Zm-9.751-9.809a2.148,2.148,0,0,1,1.1.3l8.261,4.939-2.135-9.408a2.142,2.142,0,0,1,.677-2.085l7.247-6.35-9.583-.876A2.146,2.146,0,0,1,491.5-130.8l-3.789-8.868-3.789,8.868a2.141,2.141,0,0,1-1.777,1.293l-9.585.87,7.254,6.354a2.14,2.14,0,0,1,.676,2.087l-2.139,9.408,8.261-4.939A2.147,2.147,0,0,1,487.712-116.03Zm15.765-12.546h0Z",
    transform: "translate(-467.908 144.359)",
    fill: "#473b0c"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdminSeat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adminSeat.8d7de3447a2dc3f0baee2f18ac20a49e.svg";